module.exports = __webpack_public_path__ + "0080977923e3f9e4d1a61cc649cd679a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Recipes/Assets/chicken.png
// module id = 1343
// module chunks = 0